exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".myselect-wrapper{width:100%;height:41px;overflow:visible;background:#0bbd9e;border-radius:3px;margin-bottom:20px;cursor:pointer}.myselect-wrapper .btn-wrapper{padding-left:10px;width:100%;height:41px;line-height:41px;color:#fff}.myselect-wrapper .chosen-text span{float:right;line-height:41px;margin-right:10px}.myselect-wrapper .choice-wrapper{z-index:9999;position:relative;background:#f3f4f5;opacity:1;margin-top:10px;border-radius:3px;max-height:300px;overflow:scroll}.myselect-wrapper .choice-wrapper div{height:35px;line-height:35px;padding-left:10px;background:#f3f4f5;-webkit-transition:background .5s ease;transition:background .5s ease}.myselect-wrapper .choice-wrapper div.option-wrapper:hover{background:#e1e4e7;-webkit-transition:background .5s ease;transition:background .5s ease}.chosen-text,.option-wrapper{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/controls/custom-select.vue
// module id = 62
// module chunks = 0